
import { defineComponent } from 'vue';

export default defineComponent({
	data() {
		return {
			visible: false,
			resolvePromise: undefined,
			rejectPromise: undefined,
			allowProlong: false,
			form: {
				amount: 0,
				prolong: false
			},
			rules: {
				amount: [
					{ required: true, message: this.$t('PaymentPromiseDialog.amount_required'), trigger: 'blur' }
				],
				prolong: [
					{ required: true, message: this.$t('PaymentPromiseDialog.prolong_required'), trigger: 'blur' }
				]
			}
		};
	},
	methods: {
		show(props: { amount: number, allowProlong: boolean}) {
			this.allowProlong = props.allowProlong;
			this.form.amount = props.amount;
			this.visible = true;
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve;
				this.rejectPromise = reject;
			});
		},

		async handleConfirm() {
			const valid = await this.$refs['form'].validate();
			if (!valid) {
				return;
			}

			this.visible = false;
			this.resolvePromise({
				amount: this.form.amount,
				prolong: this.form.prolong
			});
		},

		handleClose() {
			this.visible = false;
			this.resolvePromise(null);
		}
	}
});
